<template>
  <div class="">
    <b-container class="mt-4">
      <b-row>

        <b-col md="12">
          <h3><b>تواصل معنا</b></h3>
          <br>
        </b-col>
        <!-- قسم نموذج الإرسال -->
        <b-col md="6" style="padding: 30px 20px;">

          <h4 class="text-brand">أرسل لنا بريد إلكتروني</h4>
          <p class="">خذ دقيقة من وقتك</p>


          <b-form @submit.prevent="submitForm">
            <b-row>

              <b-col md="6">
                <b-form-group id="group-first_name">
                  <b-form-input placeholder="الاسم الاول" id="admin-edit-first_name" name="admin-edit-first_name"
                    v-model="$v.form.first_name.$model" :state="validateState('first_name')"></b-form-input>
                  <b-form-invalid-feedback id="input-edit-first_name">
                    {{ "الاسم الاول مطلوب" }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group id="group-last_name">
                  <b-form-input placeholder="اسم العائلة" id="admin-edit-last_name" name="admin-edit-last_name"
                    v-model="$v.form.last_name.$model" :state="validateState('last_name')"></b-form-input>
                  <b-form-invalid-feedback id="input-edit-last_name">
                    {{ "الاسم الاخير مطلوب" }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col md="12">
                <b-form-group id="group-phone">
                  <phone-input id="admin-edit-phone" v-model="$v.form.phone.$model"
                    :state="validateState('phone')"></phone-input>
                  <b-form-invalid-feedback id="input-edit-phone" :force-show="$v.form.phone.$error">
                    {{ "رقم الهاتف مطلوب" }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col md="12">
                <b-form-group id="group-subject">
                  <b-form-input placeholder="عنوان الرسالة" id="admin-edit-subject" name="admin-edit-subject"
                    v-model="$v.form.subject.$model" :state="validateState('subject')"></b-form-input>
                  <b-form-invalid-feedback id="input-edit-subject">
                    {{ "العنوان مطلوب" }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col md="12">
                <b-form-group id="group-description">
                  <b-form-textarea placeholder="الرسالة" id="admin-edit-description" name="admin-edit-description"
                    v-model="$v.form.description.$model" :state="validateState('description')"
                    rows="4"></b-form-textarea>
                  <b-form-invalid-feedback id="input-edit-description">
                    {{ "الرسالة مطلوبة" }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

            </b-row>






            <div v-if="sendSuccess" class=" mb-2 p-2 bg-success text-white rounded">
              تم ارسال البريد الالكتروني - سنتواصل معك قريبـًا
            </div>
            <div v-if="sendError" class=" mb-2 p-2 bg-dark text-white rounded">
              حدث خطأ ما
            </div>
            <div class="d-flex justify-content-ce">
              <b-button aria-label="ارسال الرسالة" type="submit" variant="brand">إرسال الرسالة</b-button>
              <b-button aria-label="اعادة تعيين" type="reset" variant="secondary" class="mr-2" @click="resetForm">إعادة
                تعيين</b-button>
            </div>

          </b-form>
        </b-col>

        <!-- قسم التواصل معنا -->
        <b-col md="6" style="padding: 30px 20px;">
          <h4 class="text-brand">هل تريد أي مساعدة</h4>
          <p class="">
            من خلال تواصلك معنا سوف نستطيع تقديم خدماتنا بشكل أفضل، هنا يتم الرد على استفساراتك بطريقة أسرع وأسهل.
          </p>

          <b-card class="mb-3">
            <div>
              <b-card-title class="text-brand">
                <b-icon-envelope-fill class="mr-2"></b-icon-envelope-fill> أرسل بريد إلكتروني
              </b-card-title>
              <p class="box-p  box-p-link" @click="gotomail(data.email)">
                <!-- mail icon -->
                <b-icon-envelope-fill class="mr-2"></b-icon-envelope-fill>

                {{ data.email }}
              </p>
            </div>
          </b-card>

          <b-card class="mb-3">
            <div>
              <b-card-title class="text-brand">
                <b-icon-telephone-fill class="mr-2"></b-icon-telephone-fill> تواصل مع فرع السعودية
              </b-card-title>
              <p class="box-p">{{ data.ksa_adderss }}</p>
              <p class="box-p box-p-link box-p-phone" @click="gotophone(data.ksa_number)">{{ data.ksa_number }}</p>
            </div>
          </b-card>

          <b-card>
            <div>
              <b-card-title class="text-brand">
                <b-icon-geo-alt-fill class="mr-2"></b-icon-geo-alt-fill> تواصل مع فرع مصر
              </b-card-title>
              <p class="box-p">{{ data.eg_adderss }}</p>
              <p class="box-p box-p-link box-p-phone" @click="gotophone(data.eg_number)">{{ data.eg_number }}</p>
            </div>
          </b-card>
        </b-col>

      </b-row>
    </b-container>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { sendRequest } from "../utils/RequestHelper.js"
import PhoneInput from "../components/auth/PhoneInput.vue"

import {
  required,
  email,
  numeric,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";
export default {
  mixins: [validationMixin],
  components: { PhoneInput },

  data() {
    return {
      form: {
        first_name: '',
        last_name: '',
        phone: '',
        subject: '',
        description: '',

      },
      sendError: false,
      sendSuccess: false,
      data: {},
    };
  },
  // validations
  validations: {
    form: {
      first_name: {
        required
      },
      last_name: {
        required
      },
      phone: {
        required
      },
      subject: {
        required
      },
      description: {
        required
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    gotomail(email) {
      window.open(`mailto:${email}`);
    },
    gotophone(phone) {
      window.open(`tel:${phone}`);
    },
    submitForm() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      this.createItem();
    },
    createItem() {
      var successCallback = () => {
        this.$bvToast.toast('تم ارسال رسالتك بنجاح !', {
          title: 'تم الارسال',
          variant: 'success',
          solid: true,
          noCloseButton: true,
          autoHideDelay: 5000,
        });
        this.pageIsLoading = false;
        this.sendSuccess = true
        this.resetForm();
      };
      var errorCallback = () => {
        this.pageIsLoading = false;
      };
      sendRequest('post', 'configuration/contact-us/', false, this.form, successCallback, errorCallback);
    },
    resetForm() {
      this.form = { first_name: '', last_name: '', phone: '', subject: '', description: '' };
      this.$v.$reset();
    },

    loadData() {
      this.pageIsLoading = true;
      var successCallback = (data) => {
        this.data = data || {}
        this.pageIsLoading = false;
      };
      var errorCallback = () => {
        this.pageIsLoading = false;
      };
      sendRequest('get', 'configuration/configuration/', false, {}, successCallback, errorCallback);
    },
  },
  created() {
    this.loadData();
  },
};
</script>

<style scoped>
h4 {
  font-weight: bold;
}

p {
  font-size: 16px;
}

.b-card {
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 0px !important;
}

.box-p {
  margin: 0;
  overflow-wrap: anywhere;
}

/* keep "+20 100 ..." in its natural order inside the RTL layout */
.box-p-phone {
  direction: ltr;
  text-align: right;
}

.box-p-link:hover {
  cursor: pointer;
}
</style>